import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import he from 'vuetify/src/locale/he'

Vue.use(Vuetify)

export default new Vuetify({
  rtl: true,
  lang: {
    current: 'he',
    locales: { he }
  },
  theme: {
    themes: {
      light: {
        primary: '#3f5bb9',
        secondary: '#e31e36',
        accent: '#27376e',
        info: '#b1c3ff',
        warning: '#fdeea4',
        anchor: '#c9c9c9',
        blackish: '#212121'
      }
    }
  }
})
